import React, { useEffect, useState, useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";
import SecBTN from "../../../UI/SecBTN";
import TableHeader from "./Header";
import Pagination from "./Pagination";
import Search from "./Search";
import classes from "./Table.module.css";
import Modals from "../../../UI/Modals/Modals";
import Input from "../../../UI/Input/Input";
import Toast from "../../../UI/Toast/Toast";
import { Link } from "react-router-dom";
import userService from "../../../app/services/user.service";
import { isPending } from "@reduxjs/toolkit";

const DataTable = (props) => {
  const x = JSON.parse(localStorage.getItem("user"));
  const [showEntries, setShowEntries] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [remarkInfo, setRemarkInfo] = useState(null);


  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;

  const ITEMS_PER_PAGE = +showEntries;

  const headers = [
    { name: "S.No.", field: "id", sortable: false },
    { name: "QID", field: "qid", sortable: true },
    { name: "Subject", field: "subject", sortable: false },
    { name: "Question", field: "question", sortable: false },
    { name: "Faculty Remark", field: "facultyRemark", sortable: false },
    { name: "Edit", field: "edit", sortable: false },

    ...(props.isPending
      ? [{ name: "Status", field: "status", sortable: false }]
      : [
        { name: "Reviewed By", field: "reviewedBy", sortable: false },
        { name: "Reviewed On", field: "reviewedOn", sortable: false }
      ])
  ];


  const commentsData = useMemo(() => {
    //let computedComments = comments;
    let computedComments = props.data;

    if (search) {
      computedComments = computedComments.filter((comment) =>
        comment.sub_name?.toLowerCase().includes(search.toLowerCase()) ||
      comment.q_text?.toLowerCase().includes(search.toLowerCase()) ||
      String(comment.q_id)?.includes(search.toLowerCase()) 

      );
    }
    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [props.data, currentPage, search, sorting, ITEMS_PER_PAGE]);
  //functions other than table
  const [dataToModal, setDataToModal] = useState({
    "sub_topic_name": "",
    "sub_topic_id": null,
    "user_id": +x?.data?.user?.user_id,
    "sub_topic_sequence": null,
    "status": null
  })
  const [index, setIndex] = useState(null)
  const [showPopUp, setShowPopUp] = useState(false)
  const onSaveHandler = () => {
    props.updateHandler(dataToModal);
    // toast.success("Changes Saved Successfully.")
    setShowPopUp(false)
  };
  const hideHandler = () => {
    setShowPopUp(false)
  };


  const handleFacultyRemarkClick = (qid, error_report_id) => {
    const payload = {
      qid,
      error_report_id,
    };
    // setShowRemarkModal(true);
    userService.FacultyErrorReportInfo(payload)
      .then((res) => {
        setRemarkInfo(res.question_report_info); // expected object or array
        console.log(res.question_report_info)
        setShowRemarkModal(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const handleStatusChange = (error_report_id, q_id) => {
    console.log(error_report_id, q_id);
    const payload = {
      qid: q_id,
      user_id: user_id,
      error_report_id
    }
    userService.FacultyErrorReportStatusChange(payload)
      .then(res => {
        console.log(res);
        props.refetchData();

        // setLoading(false);
      })
      .catch(err => {
        console.log(err);
        // setLoading(false);
        // toast.error("Failed to fetch pending reports!");
      });
  };

  return (
    <>
      <Toast />
      <Modals show={showRemarkModal} onHide={() => setShowRemarkModal(false)}>
        <h5 className="mb-3">Faculty Error Report Details</h5>

        {Array.isArray(remarkInfo) && remarkInfo.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-bordered text-center align-middle">
              <thead className="table-light">
                <tr>
                  <th>S.No</th>
                  <th>QID</th>
                  <th>Faculy Name</th>
                  <th>Description</th>
                  {/* <th>Created By</th> */}
                  <th>Reported On</th>
                </tr>
              </thead>
              <tbody>
                {remarkInfo.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.q_id}</td>
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    {/* <td>{item.created_by}</td> */}
                    <td>
                      {new Date(item.created_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-center">No remarks found.</p>
        )}

        <div className="text-center mt-4">
          <SecBTN className="sec-btn1" onClick={() => setShowRemarkModal(false)}>
            Close
          </SecBTN>
        </div>
      </Modals>


      {props.data.length == 0 ? (
        props.noDataShow && (
          <p className="text-center fw-semibold   rounded py-2 px-3">
            {props.isPending ? "Pending Faculty Error Report Questions Data Not found." : "Complete Faculty Error Report Questions Data Not found."}!!
          </p>
        )
      ) : (
        <>
          <div className="d-flex justify-content-between">
            <div>
              Show{" "}
              <select
                onChange={(e) => {
                  setShowEntries(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
              </select>{" "}
              enteries
            </div>
            <Search
              onSearch={(value) => {
                setSearch(value);
                setCurrentPage(1);
              }}
            />
          </div>
          <div className="table-responsive">
            <table className="table table-bordered mt-3 mb-0">
              <TableHeader
                className={classes.header}
                headers={headers}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {commentsData.map((data, index) => (
                  <tr key={data.sub_topic_id}>
                    <th scope="row">{index + 1}</th>
                    <td>{data.q_id}</td>
                    <td>{data.sub_name}</td>
                    <td>
                      <div dangerouslySetInnerHTML={{ __html: data.q_text }} />
                    </td>
                    <td>
                      <SecBTN
                        className="sec-btn1"
                        style={{ padding: "0.4rem 1rem", fontSize: "0.8rem" }}
                        onClick={() =>
                          handleFacultyRemarkClick(data.q_id, data.error_report_id)
                        }
                      >
                        View
                      </SecBTN>
                    </td>



                    <td><Link to={`/editQuestion/edit/${data.q_id}`}><SecBTN className='sec-btn1'>Edit</SecBTN></Link></td>
                    {props.isPending ? (
                      <td>
                        <SecBTN
                          onClick={() =>
                            handleStatusChange(data.error_report_id, data.q_id)
                          }
                          className="sec-btn1"
                          style={{ padding: "0.4rem 1rem", fontSize: "0.8rem" }}
                        >
                          {data.status == "1" ? "Active" : "In-active"}
                        </SecBTN>
                      </td>
                    ) : (
                      <>
                        <td>{data.name || "-"}</td>
                        <td>
                          {data.deleted_at
                            ? new Date(data.deleted_at)
                              .toISOString()
                              .slice(0, 19)
                              .replace("T", " ")
                            : "-"}
                        </td>
                      </>
                    )}

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="small ">
            Showing{" "}
            <b>
              {+showEntries < props.data.length
                ? +showEntries
                : props.data.length}
            </b>{" "}
            out of {props.data.length} enteries
          </p>
          <div className="mt-4">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </>
      )}
    </>
  );
};

export default DataTable;
